import { RealProject } from '@joehua/buzz-cms-types'
import { EntityImage } from '@joehua/cms-components'
import * as React from 'react'
import { themr } from 'react-css-themr'
import Link from '../Link'

export interface RealProjectCardTheme {
  root?: string
  itemWrapper?: string
  imageWrapper?: string
  image?: string
  contentWrapper?: string
  titleLink?: string
  description?: string
  publishedAt?: string
  readMoreWrapper?: string
  readMoreText?: string
}

export interface RealProjectCardProps {
  entity: RealProject
  theme?: RealProjectCardTheme
}

export const defaultRealProjectCardTheme: RealProjectCardTheme = {
  root: 'bg-white flex flex-wrap pa2 card-shadow br2',
  imageWrapper: 'w-100',
  image: 'w-100',
  contentWrapper: 'w-100 pv1 pv0-ns ph0 ph3-ns',
  titleLink: 'f5 f4-l fw6 ma0 pb2 mid-gray',
  description: 'f6 f5-l gray fw4 line-clamp',
  publishedAt: '',
  readMoreWrapper: 'pt3 pointer',
  readMoreText: 'f6 fw7 silver hover-rc',
}

const DumpRealProjectCard = ({ entity, theme = {} }: RealProjectCardProps) => {
  const to = { name: 'real-project', params: { slug: entity.slug } }
  return (
    <div className={theme.root}>
      <div className={theme.imageWrapper}>
        <Link to={to}>
          <EntityImage
            className={theme.image}
            entity={entity}
            height={300}
            usePlaceholder
            transform="w_400,h_300,c_fill"
            thumbTransform="w_40,h_30,c_fill"
          />
        </Link>
      </div>
      <div className={theme.contentWrapper}>
        <Link to={to}>
          <h3 className={theme.titleLink}>{entity.title}</h3>
        </Link>
        <div className={theme.description}>{entity.description}</div>
        <Link to={to}>
          <div className={theme.readMoreWrapper}>
            <span className={theme.readMoreText}>Xem thêm →</span>
          </div>
        </Link>
      </div>
    </div>
  )
}
const RealProjectCard = themr(
  'RealProjectCard',
  {},
  {
    composeTheme: 'softly',
  },
)(DumpRealProjectCard)

export default RealProjectCard
